import styled from "styled-components";

export const HistoricalResultsDiv = styled.div`
   background-color: white !important;
   box-shadow: 10px 3px 15px 0px rgb(0 0 0 / 28%);
`;
